import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserRoles } from '../features/auth/authSlice';

/** Client-side convenience only — the API re-checks every request via Policies/role middleware. */
export default function RoleRoute({ allow }) {
  const roles = useSelector(selectUserRoles);
  const authorized = roles.some((role) => allow.includes(role));

  if (!authorized) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
